<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" class="no-field-space">
  <sc-dialog-title>
    {{ 'mail schedules' | translate: ['tmc-yard.widgets.filter-administration.filter-mail-schedule.title',
    translationService.language]}}
  </sc-dialog-title>
  <sc-separator-line></sc-separator-line>
  <sc-flex-fitting-content [vertical]="true" class="no-field-space">
    <sc-master-detail [data]="visiblefilterMailSchedules" [readOnly]="false" [selection]="[selectedEntry]"
      (selectionChanged)="handleSelectionChange($event)" (addEntry)="onAddEntry($event);"
      (deleteEntry)="onDeleteEntry($event);">

      <ng-container *ngIf="selectedEntry">
        <app-filter-mail-schedule-editor [filterMailSchedule]="selectedEntry"
          (entryChanged)="onEntryChanged()"></app-filter-mail-schedule-editor>
      </ng-container>

    </sc-master-detail>
  </sc-flex-fitting-content>

  <sc-separator-line></sc-separator-line>
  <sc-actionbar>
    <sc-content-spacer [grow]="true"></sc-content-spacer>
    <button mat-stroked-button (click)="onCancel()">
      {{ 'cancel' | translate: ['tmc-yard.action.cancel', translationService.language]}}
    </button>
    <sc-content-spacer></sc-content-spacer>
    <button mat-stroked-button (click)="onSave()" [disabled]="!saveEnabled">
      {{ 'save' | translate: ['tmc-yard.widgets.filter-administration.filter-mail-schedule.action.confirm',
      translationService.language]}}
    </button>
  </sc-actionbar>

</sc-flex>
